import { Box } from "@mui/system";
import { Table } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFilters,
  updatePaginationRequest,
  fetchDeviceTypeRequest,
  updateUI,
  fetchalllocationRequest,
} from "../../store/actions/deviceProfile";
import {
  DropdownFilterWithDateRangePicker,
  DropdownFilterWithSearchAndCheckbox,
} from "../../components/DropdownFilter";
import DeviceProfileDropdownSingle from "./DeviceProfileDropdownSingle";
import DeviceProfileDropdown from "./DeviceProfileDropdown";
import getSingleDeviceProfile from "./utility/getSingleDeviceProfile";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

const DeviceProfileList = () => {
  const {
    isLoadingProfileDevice,
    deviceTypes,
    shouldUpdate,
    count,
    currentPage,
    profiles,
    pageSize,
    filters,
    locationList
  } = useSelector((state) => ({
    isLoadingProfileDevice: state.deviceProfile.isLoading.devices,
    deviceTypes: state.deviceProfile.ui.form.deviceTypes,
    shouldUpdate: state.deviceProfile.shouldUpdate,
    count: state.deviceProfile.data.count,
    profiles: state.deviceProfile.data.devices,
    currentPage: state.deviceProfile.data.currentPage,
    pageSize: state.deviceProfile.data.pageSize,
    filters: state.deviceProfile.filters,
     locationList: state.deviceProfile.data.locationList,
  }));
  const dispatch = useDispatch();
const user = useSelector((state) => state.auth.user);
  const handleDeviceTypeFilter = (val) => {
    dispatch(
      updateFilters({
        filters: { deviceTypes: val?.filters.checkboxItems },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "deviceType" : "createdon",
      })
    );
  };

  const handleDeviceTypeFilterReset = (val) => {
    dispatch(
      updateFilters({
        filters: { deviceTypes: [] },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "deviceType" : "createdon",
      })
    );
  };

  const handleLastUpdateFilter = (val) => {
    dispatch(
      updateFilters({
         filters: {
          lastUpdatedfrom:
            val.filters.text[0],
          lastUpdatedto:
           val.filters.text[1]? dayjs(val.filters.text[1])
                          .set("hour", 23)
                          .set("minute", 59)
                          .set("second", 59)
                          : "",},
        // filters: {
        //   lastUpdatedfrom:
        //     val?.filters?.text?.length > 0 ? dayjs(val.filters.text[0]).set('hour', 23).set('minute', 59).set('second', 59)  : "",
        //   lastUpdatedto:
        //     val?.filters?.text?.length > 0 ? val.filters.text[1] : "",
        // },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "updatedon" : "createdon",
      })
    );
  };

  const handleLastUpdateFilterReset = (val) => {
    dispatch(
      updateFilters({
        filters: { lastUpdatedto: "", lastUpdatedfrom: "" },
        sort: "desc",
        field: "createdon",
      })
    );
  };
  const handleSubjectSearch = (val) => {
    dispatch(
      updateFilters({
        filters: { description: val?.filters ? val.filters?.text : "" },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "description" : "createdon",
      })
    );
  };
  const handleNameFilter = (val) => {
    dispatch(
      updateFilters({
        filters: { profileNames: val?.filters.checkboxItems },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "profilename" : "createdon",
      })
    );
  };

  const handleProfileTypeFilter = (val) => {
    dispatch(
      updateFilters({
        filters: { profileTypes: val?.filters?.checkboxItems || [] },
        sort: val?.isAsc ? "asc" : "desc",
        field: val?.hasOwnProperty("isAsc") ? "profiletype" : "createdon",
      })
    );
  };

  const handleNameFilterReset = (val) => {
    dispatch(
      updateFilters({
        filters: { profileNames: [] },
        sort: "desc",
        field: "createdon",
      })
    );
  };

  const handleProfileTypeFilterReset = (val) => {
    dispatch(
      updateFilters({
        filters: { profileTypes: [] },
        sort: "desc",
        field: "createdon",
      })
    );
  };
  const location = useLocation();
  useEffect(() => {
  dispatch(
    updatePaginationRequest({
      data: { pageSize: 10, currentPage: 1 },
      shouldUpdate: true,
    })
  );
}, [location.pathname]); 

  const handleViewProfile = (id) => {
    if(locationList ===undefined){
      dispatch(fetchalllocationRequest());
    }
    dispatch(fetchDeviceTypeRequest());
    const singleDeviceProfile = getSingleDeviceProfile(profiles, id,deviceTypes);
    if (singleDeviceProfile === null) return;
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: true,
          type: "view",
          step: -1,
          ...singleDeviceProfile,
        },
      })
    );
  };

  let devicePlrofiles = [];
  profiles?.map((val) =>
    devicePlrofiles.push({
      id: val?.profileid,
      key: val?.id,
      userEmail: val?.email,
      profilename: val?.profilename,
      description: val?.description,
      devicetype: val?.devicetype,
      profiletype: val?.profiletype,
      updateon: val?.updatedOnFormated,
      createdon: val?.createdon,
      createdby: val?.createdby,
      value: val,
      // isValidAction,
      action: true ? (
        <DeviceProfileDropdownSingle
          id={val?.profileid}
          name={val?.profilename}
        />
      ) : null,
    })
  );

  const columns = [
    {
      title: (
        <div style={{ whiteSpace: "nowrap", padding: "0 10px" }}>
          <DropdownFilterWithSearchAndCheckbox
            text="Name"
            isSortable={true}
            onApply={handleNameFilter}
            onReset={handleNameFilterReset}
            checkboxItems={filters.profileNames}
          />
        </div>
      ),
      dataIndex: "profilename",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            minHeight: "5vh",
            alignItems: "center",
            marginLeft: 10,
          }}
        >
          <div>
            <button
              onClick={() => handleViewProfile(record?.id)}
              className="mb-0 amt-btn-link"
            >
              {text}
            </button>
          </div>
        </div>
      ),
      SortOrder: "ascend",
    },

    // Description column with dropdown filter
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
        accountId={user?.accountId}
          text="Description"
          isSortable={true}
          onApply={handleSubjectSearch}
          onReset={handleSubjectSearch}
        />
      ),
      dataIndex: "description",
      render: (text) => (
        <div style={{ display: "flex" }}>
          <p className="mb-0">{text}</p>
        </div>
      ),
      // width: "12.5%", // Equal width
    },
    // Profile Type column with dropdown filter
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Profile type"
          isSortable={true}
          onApply={handleProfileTypeFilter}
          onReset={handleProfileTypeFilterReset}
          checkboxItems={filters.profileTypes}
        />
      ),
      dataIndex: "profiletype",
      render: (text) => (
        <div style={{ display: "flex" }}>
          <p className="mb-0">{text === "nonshipment" ? "Inventory" : "Shipment"}</p>
        </div>
      ),
      SortOrder: "ascend",
    },
    // Device Model column with dropdown filter
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Device model"
          isSortable={true}
          onApply={handleDeviceTypeFilter}
          onReset={handleDeviceTypeFilterReset}
          checkboxItems={filters.deviceTypes}
        />
      ),
      dataIndex: "devicetype",
      render: (text) => (
        <div style={{ display: "flex" }}>
          <p className="mb-0">{text}</p>
        </div>
      ),
      // width: "12.5%", // Equal width
    },

    {
      title: (
        <div style={{ whiteSpace: "nowrap", padding: "10 20px" }}>
          <div>
            <div className="d-flex table_column_header">
              <DropdownFilterWithDateRangePicker
                text="Last updated"
                isSortable={true}
                onApply={handleLastUpdateFilter}
                onReset={handleLastUpdateFilterReset}
                accountId={user?.accountId}
              />
            </div>
          </div>
        </div>
      ),
      dataIndex: "updateon",
      render: (text) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <p className="mb-0">{text}</p>
          </div>
        </div>
      ),
      SortOrder: "descend",
      // width: "12.5%", // Equal width
    },
    {
      title: <DeviceProfileDropdown />,
      dataIndex: "action",
    },
  ];

  return (
    <Box
      sx={{
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopWidth: 0,
      }}
      className="shipment-list-view-container"
    >
      <Table
        loading={isLoadingProfileDevice}
        rowKey="shipment-row-key"
        className="sasp_common-table"
        columns={columns}
        dataSource={devicePlrofiles}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          total: count,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          prevIcon: ["Previous"],
          nextIcon: ["Next"],
          onChange: (page, pageSize) => {
            dispatch(
              updatePaginationRequest({
                data: { pageSize: pageSize, currentPage: page },
                shouldUpdate: !shouldUpdate,
              })
            );
          },
          showSizeChanger: true,
          locale: {
            items_per_page: "",
          },
        }}
      />
    </Box>
  );
};

export default DeviceProfileList;
